import React, { useEffect, useState } from 'react';
import { AdjuntosAdapter, Adjunto } from '../../../../../infraestructure/persistence/rest/AdjuntosAdapter';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import ListadoAdjuntos from './listado';

export const ListaAdjuntosContainer = (props:any) => {

  let {idParte, getNumberAdjuntos} = props;
  const api = new AdjuntosAdapter();
  let [adjuntos, setAdjuntos] = useState<any>(undefined)
  
  useEffect(()=>{
    getAdjuntos();
  },[])

  const getOptions = () =>{
    return adjuntos && adjuntos.map((a: Adjunto)=> { return { id: a.idAdjunto, file:{name: a.nombre, size: a.tamaño}, tipo: a.tipo } })
  }

	const getAdjuntos = async () => {
		try {
			const result = await api.ListarAdjuntos(idParte);
			setAdjuntos([ ...result.data ]);
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exception && alert("Error , " + exception.message);
		}
  };


  return <ListadoAdjuntos {...props} options={getOptions()}/>
};

export default ListaAdjuntosContainer;